
      window.ri2 = {
        getUserId: () => null,
        addItemsToCart: (items, caseId) => {
          console.log("addItemsToCart: ", items, caseId)
        },
        getPartPrices: async (items) => {
          console.log("getPartPrices:", items)
          // Return host-source price + stock status keyed by oem_number.
          return Object.fromEntries(
            items.map((item, index) => [
              item.oem_number,
              {
                price: 4999 + index,
                inventory_status: index % 2 === 0 ? "in_stock" : "out_of_stock",
              },
            ]),
          )
        },
        pageContext: null,
        setPageContext(ctx) {
          this.pageContext = ctx
          window.dispatchEvent(
            new CustomEvent("ri2:pagecontext", {detail: ctx}),
          )
          // Update the active-label indicator in the test panel
          document
            .querySelectorAll("#ri2-test-controls button")
            .forEach((b) => {
              b.style.fontWeight = "normal"
              b.style.background = "#fff"
            })
          const activeBtn = document.querySelector(
            `[data-ctx="${ctx?.pageType || "none"}"]`,
          )
          if (activeBtn) {
            activeBtn.style.fontWeight = "600"
            activeBtn.style.background = "#F0FDF4"
          }
        },
        navigateTo(path) {
          console.log("navigateTo:", path)
          window.open(path, "_blank")
        },
        getModelPageUrl(modelId) {
          return `/ProductDetail/${modelId}`
        },
        getPartDetailUrl({name, oemNumber, id}) {
          return `/PartDetail/${name}/${oemNumber}/${id}`
        },
      }
    